import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocumentationWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 41.85,
	height: 36.5,
	viewBox: "0 0 41.85 36.5",
	fill: "#fe4c4a",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "warning_FILL1_wght400_GRAD0_opsz48",
		d: "M4.6,42a1.432,1.432,0,0,1-1.3-.75,1.363,1.363,0,0,1,0-1.5L22.7,6.25a1.5,1.5,0,0,1,2.6,0l19.4,33.5a1.363,1.363,0,0,1,0,1.5,1.432,1.432,0,0,1-1.3.75ZM24.2,19.4a1.454,1.454,0,0,0-1.5,1.5v8.2a1.5,1.5,0,1,0,3,0V20.9a1.454,1.454,0,0,0-1.5-1.5Zm0,16.75a1.454,1.454,0,1,0-1.075-.425A1.457,1.457,0,0,0,24.2,36.15Z",
		transform: "translate(-3.075 -5.5)"
	})
});
export { SvgDocumentationWarning as ReactComponent };
